import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminInquiries from "@/pages/AdminInquiries";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
